// Boiler sizing - adjust form based on the method the viewer chooses.
jQuery(document).ready(function () {
  // show or hide fields
  if (jQuery('#boiler-sizing-method').val() == 'lbs_hr') {
    jQuery('#mass-fields .field-element').each(function () {
      jQuery(this).attr('disabled', 'true');
    });
  }
  else { 
    jQuery('#pounds-fields .field-element').each(function () {
      jQuery(this).attr('disabled', 'true');
    });
  }
  

  jQuery('#boiler-sizing-method').on('change', function () { 
    if (jQuery(this).val() == 'lbs_hr') {
      jQuery('#pounds-fields').css('display', 'block');
      jQuery('#mass-fields').css('display', 'none');

      // show/hide fields.
      jQuery('#mass-fields .field-element').each(function () {
        jQuery(this).attr('disabled', 'true');
      });
      jQuery('#pounds-fields .field-element').each(function () {
        jQuery(this).removeAttr('disabled');
      });
    }
    else { 
      jQuery('#pounds-fields').css('display', 'none');
      jQuery('#mass-fields').css('display', 'block');
      // show/hide fields.
      jQuery('#pounds-fields .field-element').each(function () {
        jQuery(this).attr('disabled', 'true');
      });
      jQuery('#mass-fields .field-element').each(function () {
        jQuery(this).removeAttr('disabled');
      });
    }
  });
});
